// @see mylw-lwpreprod.nexcess-internal.workers.dev
import uatTemplate from './uat';
import type { AppConfigI } from './example';

const lwpreprod: AppConfigI = {
	...uatTemplate,
	openId: {
		...uatTemplate.openId,
		client_id: 'lw-preprod-portal',
	},
	headsUpDisplay: false,
	methodic: {
		__: 'NOT A SECRET — public `STREAMING_WEB-` channel embed identifier',
		moduleUrl: 'https://widget-nexcess-prod.methodic.ai/client.js',
		apiKey: 'STREAMING_WEB-alexka_f9a-87d723bf-1ba1-4fe1-a22d-b509d113a505',
		agentId: '',
		embedType: 'popup',
		variants: [
			{ key: 'base', weight: 50 },
			{ key: 'enhanced-support', weight: 50 },
		],
	},
};

export default lwpreprod;
